import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import React, { memo, useCallback, useState } from 'react';
import { StyledCardHeader, UnstyledButton } from './styles';

export interface CollapsibleCardProps {
  title: string | React.ReactElement;
  defaultExpanded?: boolean;
  children: React.ReactElement;
}

/**
 * CollapsibleCard
 *
 * Card with a collapse icon to hide its content.
 */

export const CollapsibleCard: React.FC<CollapsibleCardProps> = ({
  title,
  defaultExpanded = true,
  children,
}) => {
  const [expanded, setExpanded] = useState(() => defaultExpanded);
  const formattedTitle = typeof title === 'string' ? <h3>{title}</h3> : title;
  const toggleExpanded = useCallback(
    () => setExpanded((expanded) => !expanded),
    [setExpanded],
  );
  return (
    <Card>
      <StyledCardHeader>
        {formattedTitle}
        <UnstyledButton onClick={toggleExpanded}>
          {expanded ? <MinusOutlined /> : <PlusOutlined />}
        </UnstyledButton>
      </StyledCardHeader>
      {expanded ? children : null}
    </Card>
  );
};

export default memo(CollapsibleCard);
